import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchPublicClientViewTransportLanding } from "../../../api/transportPublicApi";
import {
  TransportPublicAttribution,
  TransportPublicCtas,
  TransportPublicHero,
} from "../../../components/midpoint/transport/public/TransportPublicSections";
import { useTransportPublicSeo, trackTransportPublicEvent } from "../../../hooks/useTransportPublicSeo";
import TransportPublicLayout from "./TransportPublicLayout";

const TransportClientViewLandingPage = () => {
  const { clientViewKey } = useParams();
  const [payload, setPayload] = useState(null);
  const [error, setError] = useState(null);

  useTransportPublicSeo(payload?.seo);

  useEffect(() => {
    let cancelled = false;
    fetchPublicClientViewTransportLanding(clientViewKey)
      .then((body) => {
        if (!cancelled) {
          setPayload(body);
          trackTransportPublicEvent("transport_public_page_view", {
            pageType: "client_view_landing",
            clientViewKey,
          });
        }
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Unable to load page.");
      });
    return () => {
      cancelled = true;
    };
  }, [clientViewKey]);

  if (error || !payload) {
    return (
      <TransportPublicLayout title="Client View transport">
        <p>{error || "Loading transport landing…"}</p>
      </TransportPublicLayout>
    );
  }

  const counts = payload.summary?.counts || {};

  return (
    <TransportPublicLayout title={`${payload.clientView.name} transport`}>
      <TransportPublicHero
        hero={{
          title: `${payload.clientView.name} transport intelligence`,
          summary: "Client View transport dashboard summary from latest available configured sources.",
        }}
      />
      <section className="transport-public-section">
        <h2>Overview</h2>
        <div className="transport-public-grid">
          <div className="transport-public-stat">
            <div className="transport-public-stat-value">{counts.metroStations ?? "—"}</div>
            <div>Metro stations</div>
          </div>
          <div className="transport-public-stat">
            <div className="transport-public-stat-value">{counts.busStops ?? "—"}</div>
            <div>Bus stops</div>
          </div>
          <div className="transport-public-stat">
            <div className="transport-public-stat-value">{counts.communityMobilityReports ?? "—"}</div>
            <div>Community reports</div>
          </div>
        </div>
      </section>
      <TransportPublicAttribution attribution={payload.attribution} />
      <TransportPublicCtas ctas={payload.ctas} />
    </TransportPublicLayout>
  );
};

export default TransportClientViewLandingPage;
